import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

export var SignerErrorCode;

(function (SignerErrorCode) {
  // The signer module received a request to sign via an unsupported RPC method
  SignerErrorCode[SignerErrorCode["UnsupportedMethod"] = 3000] = "UnsupportedMethod"; // The user cancelled or rejected the transaction

  SignerErrorCode[SignerErrorCode["UserCancelled"] = 3001] = "UserCancelled"; // The request is missing params for the transaction.
  // Check that params is an array, and the transaction is the first object.

  SignerErrorCode[SignerErrorCode["MissingTransaction"] = 3002] = "MissingTransaction"; // The message signature request is missing expected params.
  // Check that params is an array, and that they include both a from address, and a message to sign.

  SignerErrorCode[SignerErrorCode["MissingMessage"] = 3003] = "MissingMessage"; // Missing from address in typed data request

  SignerErrorCode[SignerErrorCode["MissingFrom"] = 3004] = "MissingFrom"; // Missing typed data params. Make sure params is an array and includes
  // both a from address, and a typed data payload.

  SignerErrorCode[SignerErrorCode["MissingTypedData"] = 3005] = "MissingTypedData";
})(SignerErrorCode || (SignerErrorCode = {}));

export var SignerError = /*#__PURE__*/function (_Error) {
  _inherits(SignerError, _Error);

  var _super = _createSuper(SignerError);

  function SignerError(message, code) {
    var _this;

    _classCallCheck(this, SignerError);

    _this = _super.call(this, message);
    _this.name = 'TransactionError'; // Maintains proper stack trace for where our error was thrown (only available on V8)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), SignerError);
    }

    _this.code = code;
    return _this;
  }

  _createClass(SignerError, null, [{
    key: "UnsupportedMethod",
    value: function UnsupportedMethod() {
      return new SignerError('The method requested is not currently supported.', SignerErrorCode.UnsupportedMethod);
    }
  }, {
    key: "UserCancelled",
    value: function UserCancelled() {
      return new SignerError('The user cancelled this transaction', SignerErrorCode.UserCancelled);
    }
  }, {
    key: "MissingTransaction",
    value: function MissingTransaction() {
      return new SignerError('Could not find transaction in request', SignerErrorCode.MissingTransaction);
    }
  }, {
    key: "MissingMessage",
    value: function MissingMessage() {
      return new SignerError('Could not find message params in request', SignerErrorCode.MissingMessage);
    }
  }, {
    key: "MissingFrom",
    value: function MissingFrom() {
      return new SignerError('Could not find from address in request params.', SignerErrorCode.MissingFrom);
    }
  }, {
    key: "MissingTypedData",
    value: function MissingTypedData() {
      return new SignerError('Could not find data to sign in request params.', SignerErrorCode.MissingTypedData);
    }
  }]);

  return SignerError;
}( /*#__PURE__*/_wrapNativeSuper(Error));